import type { ExtractionCorpusEstimate } from "@/features/data-curation/types";

export const ROW_LIMIT_CONTACT = "learn@gxl.ai";

export const formatCount = (value: number) => value.toLocaleString("en-US");

/** Whether CorpusCountText has a count, or a running count, to show. */
export const hasCorpusCount = (estimate?: ExtractionCorpusEstimate | null) =>
  estimate?.status === "running" ||
  (estimate?.status === "complete" && estimate.matched_papers != null);

const SOURCE_NAMES: Record<string, string> = {
  arxiv: "arXiv",
  biomedrxiv: "bioRxiv/medRxiv",
  pmc: "PMC",
  openalex: "OpenAlex",
  nature_reviews: "Nature reviews",
  openreview: "OpenReview",
};

/** The corpora of a count, such as "arXiv, bioRxiv/medRxiv, and PMC". */
export const corpusSourcesText = (sources: string[]) => {
  const names = sources.map((source) => SOURCE_NAMES[source] ?? source);
  if (names.length <= 2) return names.join(" and ");
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
};
